<template xmlns="http://www.w3.org/1999/html">
  <div class="main">
    <div style="width: 100%;background-color:rgb(3, 3, 3);height: 100vh;display: flex;flex-direction: column;justify-content:space-between;overflow:auto;align-items: center;">
      <div style="position: absolute;top: 0;text-align: center;left: 8%;height: 18%;display: flex;flex-direction: column;justify-content:flex-end;align-items: center;">
        <img src="/static/images/jiatang/logo.png" alt="" width="72%"  style="top: 0;">
      </div>

     
      <div class="text-center" v-if="antiTrue" >
        <div  style="width: 100%;border: 0px solid;color: rgb(146, 146, 154);">
          <div style="width: 100%;display: flex;justify-content:center;text-align: center;font-size: 10px;">
                          当前查询数码
          </div>   
          <div style="width: 100%;display: flex;justify-content:center;text-align: center;font-size: 10px;">
                          防伪码：{{ this.antiCode }}
          </div>
          <div style="width: 100%;margin-top: 14px;display: flex;justify-content:center;font-size: 9px;">
            您的产品已被认证为官方正品，
          </div> 
          <div style="width: 100%;display: flex;justify-content:center;font-size: 9px;">
            为维护您的合法权益严防假冒伪劣，
          </div> 
          <div style="width: 100%;display: flex;justify-content:center;font-size: 9px;">
            每个防伪码仅限验证一次，感谢您的理解！
          </div> 
        </div>
      </div>

      <div class="text-center2" v-if="antiFalse" >
        <div  style="width: 100%;border: 0px solid;color: rgb(146, 146, 154);">
          <div style="width: 100%;display: flex;justify-content:center;text-align: center;font-size: 10px;">
                          当前查询数码
          </div>   
          <div style="width: 100%;display: flex;justify-content:center;text-align: center;font-size: 10px;">
                          防伪码：{{ this.antiCode }}
          </div>
          <div style="width: 100%;margin-top: 11px;display: flex;justify-content:center;font-size: 10px;">
                          首次查询时间
          </div>  
          <div style="width: 100%;display: flex;justify-content:center;font-size: 10px;">
            {{ $moment(this.firstQueryTime).format("YYYY年MM月DD日HH点mm分ss秒")  }}
          </div> 
          <div style="width: 100%;margin-top: 11px;display: flex;justify-content:center;font-size: 10px;">
            序列码已被重复使用，请谨防仿冒，
          </div> 
          <div style="width: 100%;display: flex;justify-content:center;font-size: 10px;">
            我们期待再次为您提供帮助，感谢您的支持！
          </div> 
        </div>
      </div>

      <div style="text-align: center;position: absolute;bottom: 0;">
        <img src="/static/images/jiatang/bottom.png" alt="" style="width: 100%;"/>
      </div>
      
    </div>

    <div v-show="isShow">
      <div id="fixedBg"></div>
      <p class="loading_p" id="loadP">
        <img src="/static/images/loadding.gif"/>
      </p>
    </div>
  </div>
</template>

<style scoped src="../../assets/css/index.css"></style>

<style scoped src="../../assets/css/style.css"></style>


<style scoped>
.text-center {
  position: absolute;
  top:33%;
  width: 100%;
  height: auto;
  padding: 0px 5% 0px 5%;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
.text-center2 {
  position: absolute;
  top:32%;
  width: 100%;
  height: auto;
  padding: 0px 5% 0px 5%;
  word-wrap: break-word;
  overflow-wrap: break-word;
}
</style>

<script>
import { getAntiResult, getInfoByCode } from '../../api/api'

export default {
  data() {
    return {
      isShow: false,
      antiCode:"",
      firstQueryTime:"",
      antiTrue:false,
      antiFalse:false
    }
  },
  methods: {
    getResult() {
      this.isShow = true
      const params = this.$route.query;
      const code = params.c;
      getAntiResult(code).then(res => {
        const data = res.data;
        if (data == null || data.code == "500") {
          this.isShow = false
          this.antiFalse=false
          this.antiTrue=false
          alert("防伪查询失败,请联系管理员");
        }else if(data.code == "300106"){
          this.antiFalse=false
          this.antiTrue=false
          alert(data.message);
        } else {
          this.antiCode=this.insertSpace(data.data.code)
          this.firstQueryTime=data.data.firstQueryTime
          if(data.code==="300102"){
            this.antiFalse=true
            this.antiTrue=false
          }else if(data.code=="300101"){
            this.antiFalse=false
            this.antiTrue=true
          }
        }
        this.isShow = false
      }).catch(err =>
          {
            this.isShow=false
            alert("查询异常，请联系管理员")
          }
      )

    },

    insertSpace(code){
      return code.replace(/\d{4}/g, function(match) {
      return match + ' ';
      });
    }
  },
  created: function () {
    this.getResult()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/JiaTang/Index.vue